import React, { useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import styled from 'styled-components';
import { CTA } from "../general/Button";
import config from "../../config/channels";

type TinyModalProps = {
    onHide: () => void;
    show: boolean;
    header?: string;
    footer?: JSX.Element;
    html?: string;
    children?: JSX.Element;
    className?: string;
    scrollHeader?: boolean;
    modalID?: string | null;
    backdropClassName?: string;
};

const TinyModal = ({
    show,
    header,
    footer,
    children,
    modalID = null,
    html,
    onHide,
    backdropClassName,
    className,
}: TinyModalProps) => {

    useEffect(() => {
        if (modalID) {
            document.getElementById(modalID)?.classList.add('anim-enter');
        }
        return () => {
            if (modalID) { document.getElementById(modalID)?.classList.remove('anim-enter') }
        };
    }, [show]);

    return (
        <TinyModalWrapper
            show={show}
            onHide={onHide}
            size="lg"
            backdrop={true}
            centered
            animation={false}
            id={modalID}
            backdropClassName={backdropClassName}
            className={className}
        >
            {header ? (
                <Modal.Header>
                    <h2 className='modal__title'>{header}</h2>
                    <div className="modal-close__wrapper">
                        <button role="button" className={'modal-close__btn'} onClick={() => onHide()}>
                            <span className="material-symbols-outlined">close</span>
                        </button>
                    </div>
                </Modal.Header>
            ) : null}
            <Modal.Body>
                <div className="modal-body-container">
                    {html ? <div dangerouslySetInnerHTML={{ __html: html }}/> : children}
                </div>
            </Modal.Body>
            {footer ? (
                <Modal.Footer>
                    <div className="footerContent">
                        {footer}
                    </div>
                </Modal.Footer>
            ) : null}
        </TinyModalWrapper>
    );
};

const TinyModalWrapper = styled(Modal)`
    .modal__inset {
        padding: 16px;
        background-color: var(--bg-grey);
        border-radius: var(--radius_xl);
    }

    .modal-dialog .modal-content {
        @media screen and (min-width: 768px) {
            width: 480px;
            max-width: none;
        }
    }

    .modal-dialog {
        width: 100%;
        max-width: none;
        margin: 0;
        height: 100%;
    }

    .modal-header {
        display: flex;
        align-items: center;
        height: 56px;
        background-color: transparent;
        z-index: 1;
        width: 100%;
        padding: 16px;

        > div { width: 100% }

        .modal__title {
            margin-bottom: 0;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            padding-right: 40px;
            font-family: var(--text_body_font);
            letter-spacing: var(--text_body_font_spacing);
            text-transform: var(--text_body_font_case);
        }

        &.modal-show-header .modal__title {
            opacity: 1;
        }
    }

    .modal-body {
        overflow-y: auto;

        p:last-child {
            margin-bottom: 0;
        }
    }

    .modal-footer {
        transition: box-shadow 0.15s ease-in-out;
        border-top: none;

        .footerContent {
            width: 100%;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            margin: 0 auto;
            gap: 16px;
        }
    }
`;

export default TinyModal;
